<template>
  <transition name='fade'>
    <div
      class="modal"
      v-if='visible && articleInfo.id'
      style="z-index:100;"
    >
      <div class="article_view_content">
        <div class="article_view_title msp_icon_close">
          <span class="name">预览</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="article_view_detail">
          <div
            class="article_operate"
            v-if="articleInfo.hasOwnProperty('id')"
          >
            <operation :operateData='articleInfo'></operation>
            <el-button
              type="primary"
              v-if='(preViewArticleType === "preViewMyAuditContent" || preViewArticleType === "sendAuditMessageContent") && auditArticleData.audit_status==="doing"'
              @click.native='auditCurrentArticle()'
            >审核</el-button>
            <el-button
              type="primary"
              v-if='preViewArticleType === "preViewMySendAuditContent" && auditArticleData.audit_status==="doing"'
              @click.native='undoSendAudit()'
            >撤销送审</el-button>
          </div>
          <div class="article_info_detail">
            <msp-details
              :articleDetail='articleInfo'
              :isShowAuditInfo='isShowAuditInfo'
              :isShowauditOtherInfo='isShowauditOtherInfo'
              :auditInfo='auditArticleData'
              :isShowShareInfo='isShowShareInfo'
            ></msp-details>
          </div>
          <div class="article_info_logs">
            <everylogs
              :isCanInsert='false'
              :showOuterLock='false'
              ref='articleLogsrefs'
            ></everylogs>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'
import operation from '../../manuscriptrepo/operation'
import everylogs from '../../editorArticle/everylogs'
import mspDetails from '../../manuscriptrepo/mspDetails'
import logsMixins from '../../../mixins/logs'
export default {
  name: 'previewArticle',
  mixins: [logsMixins],
  data () {
    return {
      articleInfo: {},
      preViewArticleType: '',
      isShowAuditInfo: false,
      auditArticleData: {},
      isShowauditOtherInfo: false,
      timer: null,
      isShowShareInfo: false

    }
  },

  mounted () {
    this.$root.eventHub.$on('previewArticleModel', (data, type) => {
      this.$store.commit('SET_PREVIEW_SHOW', true)
      this.preViewArticleType = type
      var currentArticleId = ''
      if (type === 'preViewtext' || type === 'newArticleMessageContent') {
        currentArticleId = data.id
        this.articleInfo = data
        this.isShowAuditInfo = false
      } else if (type === 'preViewLastEidotrArticle') {
        currentArticleId = data.id
        var url = _API_ + 'api/article/editor/get_article'
        var option = {
          ...this.$store.getters.baseOption,
          'params': {
            "list_id": [data.id]
          }
        }
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.articleInfo = res.data[0]
          }
        }).catch((error) => {
          console.log(error)
        })
      }
      else if (type === 'preViewMyAuditContent' || type === 'preViewMySendAuditContent' || type === 'sendAuditMessageContent' || type === 'resultAuditMessageContent') {
        currentArticleId = data.content.id
        this.articleInfo = data.content
        this.auditArticleData = data
        this.isShowAuditInfo = true
        this.isShowauditOtherInfo = true
      }
      else if (type === 'shareArticleMessageContent') {
        currentArticleId = data.articleId
        this.articleInfo = data.article
        this.auditArticleData = data
        this.isShowShareInfo = true
      }
      else if (type === 'preViewMyShareArticle') {
        currentArticleId = data.articleId
        this.articleInfo = data.article
        this.auditArticleData = data
      }
      else if (type === 'preViewLastEidotrArticleDoc') {
        currentArticleId = data.id
        var url = _API_ + 'api/article/doc/getter/get_doc'
        var option = {
          ...this.$store.getters.baseOption,
          'params': {
            "list_id": [data.id]
          }
        }
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.articleInfo = res.data[0]
          }
        }).catch((error) => {
          console.log(error)
        })
      }

      this.getCommentList(currentArticleId)
      this.getOperateLogs(currentArticleId)
      this.getAuditLogs(currentArticleId)
      this.getHistoryRecordList(currentArticleId)
      this.getRelatedMatters(currentArticleId)

      if (this.articleInfo.flag_sys_source && (this.articleInfo.flag_sys_source == "news_recover" || this.articleInfo.flag_sys_source == "news_topic")) {    //获取新闻选题
        this.getNewsTopicData(currentArticleId)
      }
      if (this.articleInfo.sort_form_status && this.articleInfo.sort_form_status == "yes") {            //获取串联单
        this.getSortFormData(currentArticleId)
      }
      this.setNewsTopicShow()

    })

  },

  computed: {
    articleId () {
      return this.articleInfo.id
    },
    visible () {
      return this.$store.state.repoList.showPreviewArticle
    },
    articleMspObj () {
      return this.articleInfo
    }
  },
  destroyed () {
    this.$root.eventHub.$off('previewArticleModel')
  },
  components: {
    operation,
    everylogs,
    mspDetails
  },
  methods: {
    setNewsTopicShow () {
      var self = this
      this.timer = setTimeout(() => {
        if (self.$refs.articleLogsrefs) {
          self.$refs.articleLogsrefs.changeTabDataRole(self.articleInfo)
        }
      }, 500);

    },
    closeBox () {
      this.$store.commit('SET_PREVIEW_SHOW', false)
      window.parent.postMessage('closeSortForm', '*');
      clearTimeout(this.timer)
      this.timer = null

    },
    auditCurrentArticle () {
      this.$root.eventHub.$emit('auditArticleModel', this.auditArticleData, 'normalAudit')
    },
    undoSendAudit () {
      var option = {
        ...this.$store.getters.baseOption,
        "params": {                       // 必须字段： 参数
          "id": this.auditArticleData.id,               // 必须字段：审核条目的 ID
          "audit_status": 'cancel',  // 必须字段：审核通过为  yes  审核不通过为  no   审核通过并指定下一个审核人为  doing 取消审核 cancel
          "id_to_user": '',  // 关联的可选（必须）字段：下一步审核人的 ID。当 audit_status 的值为 doing 时，此字段必须填。
          "comment": '',            // 可选字段：审核的评论内容
          "content_type": "article",
        }
      }
      var url = _API_ + 'api/article/audit/do_audit'
      this.$confirm('确认撤销送审', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.$root.eventHub.$emit('deleteCurrentSendAudit', this.auditArticleData)
            this.$set(this.articleInfo, 'id', '')
          }
        }).catch((error) => {
          console.log(error)
        })

      }).catch(() => {
        console.log('取消')
      });
    }


  },
  watch: {

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.article_view_content
  position relative
  z-index 100
  width 80%
  height 90%
  border-radius 6px
  background rgba(233, 234, 236, 1)

  .article_view_title
    box-sizing border-box
    padding 0 20px 0 20px
    width 100%
    height 48px
    border-radius 6px 6px 0px 0px
    background rgba(255, 255, 255, 1)
    box-shadow 0px 0px 4px 0px rgba(0, 0, 0, 0.2)

    span
      color #303133
      font-size 16px
      line-height 48px

    span.iconfont
      float right
      color #606266
      font-size 20px
      cursor pointer

  .article_view_detail
    position relative
    z-index 99
    display flex
    box-sizing border-box
    margin-top 6px
    padding-left 120px
    height calc(100% - 56px)

    .article_operate
      position relative
      display flex
      flex-direction column
      justify-content center
      align-items center

      button
        position relative
        display block
        box-sizing border-box
        margin-top 10px
        margin-top 6px
        padding-left 10px
        width 94px
        height 36px
        border-radius 5px 0 0 5px
        background #688EFF
        box-shadow -1px 0px 4px 0px rgba(0, 0, 0, 0.2)
        color #fff
        text-align center
        font-size 14px
        line-height 36px
        line-height 0
        cursor pointer

        &:hover
          background #688EFF !important
          color #fff !important

    .article_info_detail
      flex 1
      overflow auto
      margin-right 0px
      height 100%
</style>
